import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service8 from "../../assets/images/service/08.jpg";

const UTI = () => {

const data = {
title:"UTI Treatment",
subtitle:"Urine infection specialist at BBMH Hospital",

heading:"Best UTI Treatment",
description:"Urinary tract infection (UTI) causes burning urination, pain and frequent urination. At BBMH Hospital Bhilwara, advanced diagnosis and treatment ensures quick relief and prevention of recurrent infection.",

image:Service8,

sections:[

{
title:"What is Urinary Tract Infection (UTI)?",
content:"Urinary Tract Infection (UTI) is a common infection affecting urinary system including kidneys, bladder, ureters and urethra. It occurs when bacteria enter urinary tract and cause infection. UTI is more common in women but can affect men and children as well. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced diagnosis and effective treatment for urinary infections ensuring quick relief and prevention of recurrence."
},

{
title:"Symptoms of UTI",
content:"Common symptoms of urinary tract infection include:",
list:[
"Burning sensation during urination",
"Frequent urge to urinate",
"Pain or pressure in lower abdomen",
"Cloudy or foul-smelling urine",
"Blood in urine",
"Fever or chills in severe cases",
"Pain in lower back or sides"
]
},

{
title:"Causes of UTI",
content:"UTI usually occurs due to bacterial infection but several factors may increase risk:",
list:[
"Bacterial infection in urinary tract",
"Poor personal hygiene",
"Low water intake",
"Holding urine for long time",
"Kidney stones",
"Diabetes",
"Weak immune system",
"Use of urinary catheter"
]
},

{
title:"Diagnosis of UTI",
content:"Accurate diagnosis helps in proper treatment. Doctor may recommend:",
list:[
"Urine routine examination",
"Urine culture test",
"Ultrasound of kidney and bladder",
"Blood tests if infection severe",
"CT scan in recurrent cases"
]
},

{
title:"Treatment for UTI",
content:"Treatment depends on severity of infection:",
list:[
"Antibiotic medications",
"Pain relief medicines",
"Hydration therapy",
"Treatment of underlying cause",
"Preventive care for recurrent infection"
]
},

{
title:"Prevention Tips for UTI",
content:"Simple lifestyle changes can help prevent urinary infection:",
list:[
"Drink plenty of water daily",
"Maintain proper hygiene",
"Avoid holding urine for long",
"Urinate after intercourse",
"Control diabetes",
"Healthy diet and lifestyle"
]
},

{
title:"Female Urology Care",
content:"Women are more prone to urinary infections and bladder issues. Specialized female urology care at BBMH Hospital ensures proper diagnosis and treatment for recurrent UTI, bladder problems and urinary incontinence with complete privacy and care."
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for UTI Treatment?",
content:"Dr. Sachitanand Chaurasia is a trusted and experienced urologist providing advanced treatment for urinary tract infections and bladder problems. At BBMH (Brijesh Banger Memorial Hospital), patients receive accurate diagnosis, modern treatment and complete care. The focus is on fast relief, prevention of recurrence and long-term urinary health."
}

],

faq:[
{q:"How long UTI lasts?",a:"Usually 3-5 days with treatment."},
{q:"Is UTI serious?",a:"If untreated it can affect kidneys."},
{q:"Prevention?",a:"Drink more water & maintain hygiene."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default UTI;
